import React from 'react';
import './outputField.less';
import SafeHtml from '../../safeHtml';
import parse from 'html-react-parser';

export interface OutputFieldProps {
	/**  Name of the output field */
	outputLabel?: string;
	/**  Value of the output field */
	outputText?: string;
	/**  Inline orientation of the output field */
	orientation?: 'vertical' | 'horizontal';
	/**  Is html text */
	isHtmlText?: boolean;
	/** Content Render Prop */
	additionalContent?: () => React.ReactNode;
}

export const OutputField: React.SFC<OutputFieldProps> = ({
	outputLabel,
	outputText,
	orientation,
	additionalContent,
	isHtmlText,
}: OutputFieldProps): JSX.Element => {
	const outputContent = outputText && isHtmlText ? <SafeHtml html={outputText} /> : outputText;

	return (
		<div className="ds-output-field">
			<div className={`output-label ${orientation === 'vertical' ? '' : orientation}`}>{outputLabel}</div>
			{outputContent ? (
				<div className="output-text">
					<span className={`${isHtmlText && outputText ? 'white-space-span' : ''}`}>
						{isHtmlText && outputText && typeof outputContent === 'string'
							? parse(outputContent)
							: outputContent}
					</span>
				</div>
			) : (
				''
			)}
			{additionalContent ? (
				<div className="additionalContent">
					<span>{additionalContent && additionalContent()}</span>
				</div>
			) : (
				''
			)}
		</div>
	);
};

export default OutputField;
